// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1ezPC","bigColWidth":"Table_bigColWidth__2Zl3V","biggerColWidth":"Table_biggerColWidth__3i4Ou","row":"Table_row__fJ5YK","col":"Table_col__iLzup"};